import BasicButton from "components/General/BasicButton";
import { useNavigate } from "react-router-dom"
import {BirdTooltips}  from "utils/ToolTipConst";
import { birdTypeStuff } from "utils/game-information-constants";
import InfoPopout from "components/Wrappers/InfoPopout";

export default function BirdLegend() {
    const birds = Object.values(birdTypeStuff);
    const keys = Object.keys(birdTypeStuff);

    return (

    <div className="flex flex-row space-x-4 p-2 overflow-x-auto">
      {birds.map((bird, index) => (
        <div key={index} className="flex flex-col items-center">
          <div className="h-10 w-10">
            <img
                src={bird.icon}
            />
          </div>
          <label className="text-sm text-center">{bird.label}</label>

          <InfoPopout
            maxWidth={400}
            popupContent={BirdTooltips[keys[index]] ?? (<div>A bird</div>)} />
        </div>
      ))}
    </div>
    );
}
